import HubspotAPI from "./hubspot"

export default (apiKey, jwt) => new HubspotAPI(apiKey, jwt)
